import React from "react";
import styles from "./plantVsCostTable.module.scss";
import { Loader } from "../Loader";

const plantVsCostTable = ({ data }) => {
  return data.length !== 0 ? (
    <div className={styles.tableDivContainer}>
      <table className={styles.tableContainer}>
        <thead className={styles.tableContainer}>
          <tr className={styles.tableContainerHeaderRowMain}>
            <th>Plant / Month</th>
            <th>{/* Keys */}</th>
            {data[0].data.map((item, index) => (
              <th key={index}>
                {item.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((plant, index) => (
            <TableRow key={index} name={plant.plant_name} values={plant.data} />
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className={styles.containers}><Loader/></div>
  );
};
const TableRow = ({ name, values }) => {
  return (
    <tr className={styles.tableContainerHeaderRow}>
      <td>
        <div>
          <div>
            <p className={styles.cell}>{name}</p>
          </div>
        </div>
      </td>
      {/* Display column headers */}
      <td>
        {values[0] &&
          values[0]?.plant_yearly_data &&
          Object.keys(values[0].plant_yearly_data).map((key, index) => (
            <p className={styles.cell} key={index}>
              {key}
            </p>
          ))}
      </td>
      {/* Iterate over each data object */}
      {values.map((data, index) => (
        <td key={index} style={{ textAlign: "center" }}>
          {/* Check if user_yearly_data is an object */}
          {typeof data.plant_yearly_data === "object" ? (
            // If yes, iterate over keys of first object
            Object.keys(values[0].plant_yearly_data).map((key) =>
              // Check if current object has the key
              Object.keys(data.plant_yearly_data).includes(key) ? (
                // If yes, display corresponding data
                <p className={styles.cell} key={key}>
                  {data.plant_yearly_data[key] !== undefined
                    ? data.plant_yearly_data[key]
                    : " - "}
                </p>
              ) : (
                // If no, display dash
                <p className={styles.cell} key={key}>
                  -
                </p>
              )
            )
          ) : (
            // If plant_yearly_data is not an object, display data or dash
            <p className={styles.cell}>
              {data.plant_yearly_data !== undefined
                ? data.plant_yearly_data
                : " - "}
            </p>
          )}
        </td>
      ))}
    </tr>
  );
};

export default plantVsCostTable;
